import React from "react"
import { makeStyles } from "@material-ui/core"

import { getLog } from "../helpers/helpers"


const useStyles = makeStyles((theme) => ({
	glowing_border: {
		border: "0px",
		borderRadius: "7px",
		transition: "all 0.1s ease-in-out",
		"&:hover, &:focus-visible": {
			border: "1px solid lightgrey",
			outline: "none",
			borderColor: "white",
			boxShadow: "0 0 10px white",
		},
		"&:active": {
			transform: "scale(0.98)",
			opacity: 0.85,
		}
	},
}))


/**
 *  props:
 * 		no specific props, pass any props to transfer them
*/
export default function GlowingHoverDiv(props) {
	const classes = useStyles()

	const classname = "GlowingHoverDiv: "
	const function_id = classname
	const log = getLog(function_id)

	return (
		<div className={classes.glowing_border} {...props}>
			{props.children}
		</div>
	)
}
